@if (isLoading) {
  <span class="ggc-loader fa-spin fas fa-spinner"></span>
}
